var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstLanding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 159,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 86,
    cy: 140.057,
    rx: 86,
    ry: 18.838,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.61 147.297c15.35 0 27.794-1.309 27.794-2.923s-12.444-2.923-27.795-2.923c-15.35 0-27.794 1.309-27.794 2.923s12.444 2.923 27.794 2.923z",
    fill: "#E5E8FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.42 142.036H61.027c-2.123 0-3.86-1.754-3.86-3.897V99.172c0-2.143 1.737-3.897 3.86-3.897h44.393c2.124 0 3.861 1.754 3.861 3.897v38.967c0 2.143-1.737 3.897-3.861 3.897z",
    fill: "#E5E8FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.957 134.243h11.581M62.957 118.656h11.581M62.957 103.069h11.581",
    stroke: "#5D6BCE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.874 105.991c1.6 0 2.895-1.308 2.895-2.922 0-1.615-1.296-2.923-2.895-2.923s-2.895 1.308-2.895 2.923c0 1.614 1.296 2.922 2.895 2.922zM102.525 121.578c1.599 0 2.896-1.308 2.896-2.923 0-1.614-1.297-2.922-2.896-2.922s-2.895 1.308-2.895 2.922c0 1.615 1.296 2.923 2.895 2.923zM92.874 121.578c1.6 0 2.895-1.308 2.895-2.923 0-1.614-1.296-2.922-2.895-2.922s-2.895 1.308-2.895 2.922c0 1.615 1.296 2.923 2.895 2.923zM102.525 137.165c1.599 0 2.896-1.309 2.896-2.923s-1.297-2.922-2.896-2.922-2.895 1.308-2.895 2.922 1.296 2.923 2.895 2.923zM92.874 137.165c1.6 0 2.895-1.309 2.895-2.923s-1.296-2.922-2.895-2.922-2.895 1.308-2.895 2.922 1.296 2.923 2.895 2.923z",
    fill: "#fff",
    stroke: "#5D6BCE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.42 142.036H61.027c-2.123 0-3.86-1.754-3.86-3.897v-11.69h52.114v11.69c0 2.143-1.737 3.897-3.861 3.897zM109.281 110.862H57.166v15.587h52.115v-15.587zM109.281 110.862H57.166v-11.69c0-2.143 1.738-3.897 3.86-3.897h44.394c2.124 0 3.861 1.754 3.861 3.897v11.69z",
    stroke: "#5D6BCE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M121.247 23.575c.193-.974.386-2.143.386-3.117 0-7.404-5.983-13.639-13.511-13.639-3.088 0-5.79.974-8.106 2.728C95.19 3.702 87.856 0 79.556 0c-14.862 0-26.83 12.08-26.83 27.082v.195c-.578 0-1.157-.195-1.736-.195-7.335 0-13.318 6.04-13.318 13.639 0 7.404 5.983 13.444 13.318 13.444h60.414c9.264 0 16.792-7.6 16.792-16.951.193-5.456-2.702-10.521-6.949-13.639zM129.933 112.226c-.193.974-1.158 1.559-2.123 1.169l-27.987-7.599c-.965-.195-1.544-1.169-1.158-2.143l5.79-21.627c.193-.974 1.158-1.558 2.123-1.169l5.019 1.364 2.509 4.286 19.687 5.261c.966.195 1.545 1.169 1.159 2.143l-5.019 18.315z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.933 112.226c-.193.974-1.158 1.559-2.123 1.169l-27.987-7.599c-.965-.195-1.544-1.169-1.158-2.143l5.79-21.627c.193-.974 1.158-1.558 2.123-1.169l5.019 1.364 2.509 4.286 19.687 5.261c.966.195 1.545 1.169 1.159 2.143l-5.019 18.315zM62.764 52.8l-8.686 10.717c-1.351 1.753-1.158 4.091.579 5.455 1.737 1.364 4.053 1.17 5.404-.584l2.316-2.923c2.124 9.742 10.616 16.95 20.846 16.95 2.123 0 3.86-1.753 3.86-3.896s-1.737-3.897-3.86-3.897c-6.562 0-11.967-4.676-13.318-10.91l3.86 3.312c1.738 1.364 4.054 1.169 5.405-.585.579-.779.965-1.558.965-2.532 0-1.17-.386-2.144-1.351-2.923l-10.616-8.768c-.772-.584-1.737-.974-2.895-.78-.772.196-1.737.585-2.51 1.365zM83.223 39.747c-2.123 0-3.86 1.753-3.86 3.896s1.737 3.897 3.86 3.897c6.563 0 11.967 4.676 13.318 10.91l-3.86-3.311c-1.737-1.364-4.053-1.17-5.404.584s-1.158 4.092.579 5.456l10.616 8.767c.772.585 1.737.974 2.895.78.965-.195 1.93-.585 2.702-1.364l8.686-10.716c.579-.78.965-1.559.965-2.533 0-1.17-.386-2.143-1.351-2.923-1.737-1.363-4.054-1.169-5.405.585l-2.316 2.922c-2.702-9.742-11.195-16.95-21.425-16.95z",
    stroke: "#5D6BCE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.396 107.355c.193.974-.386 1.948-1.158 2.143l-23.162 6.235c-.965.195-1.93-.39-2.123-1.169l-7.335-27.667c-.193-.974.386-1.948 1.159-2.143l15.827-4.287 11.195 6.43 5.597 20.458z",
    fill: "#fff",
    stroke: "#5D6BCE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.797 80.468l2.316 8.767 8.879-2.338-11.195-6.43z",
    fill: "#fff",
    stroke: "#5D6BCE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M45.585 96.25l-3.088 6.234 5.984 2.923M53.692 93.522l6.176 3.117-3.088 6.04M50.41 103.069l.966-7.794",
    stroke: "#5D6BCE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgFirstLanding;